import { useRef, useCallback } from "react";

export const useReformatterWebSocket = ({
  wsURL,
  randomRoom_id,
  setGetReformatterSocket,
  SetReFormatterLoading,
  setReFormatterData,
  setReformatterReconnectAttempts,
  reformatterReconnectAttempts,
  shouldReconnectRef,
  token,
}) => {
  const connectReformatterWebSocket = useCallback(
    (payload) => {
      let reconnectInterval = 1000;
      const maxReconnectInterval = 30000;
      const reconnectDecay = 1.5;
      const maxReconnectAttempts = 5;

      const newWebSocketURL = `${wsURL}ws/latex-reformatter/${randomRoom_id}/?token=${token}`;
      const socket = new WebSocket(newWebSocketURL);

      setGetReformatterSocket(socket);

      socket.onopen = () => {
        setReformatterReconnectAttempts(0);
        reconnectInterval = 1000;

        if (payload) {
          socket.send(JSON.stringify(payload));
        }
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data && data.message) {
            const message = data.message;

            if (message === "No LaTeX input provided.") {
              SetReFormatterLoading(false);
              return;
            }

            if (message.includes("<ENDOFTURN>")) {
              SetReFormatterLoading(false);
              setReFormatterData(data.full_response);
              shouldReconnectRef.current = false;
            }
          }
        } catch (error) {
          console.error("❌ Error processing WebSocket message:", error);
        }
      };

      socket.onclose = () => {
        if (
          shouldReconnectRef.current &&
          reformatterReconnectAttempts < maxReconnectAttempts
        ) {
          setTimeout(() => {
            setReformatterReconnectAttempts((prev) => prev + 1);
            reconnectInterval = Math.min(
              reconnectInterval * reconnectDecay,
              maxReconnectInterval
            );
            console.log(
              `🔁 Reconnecting... Attempt ${reformatterReconnectAttempts + 1}`
            );
            connectReformatterWebSocket(payload);
          }, reconnectInterval);
        } else {
          console.log("🛑 WebSocket closed — no reconnection needed.");
        }
      };

      socket.onerror = (error) => {
        console.error("⚠️ WebSocket error:", error);
        socket.close();
      };
    },
    [
      wsURL,
      randomRoom_id,
      setGetReformatterSocket,
      SetReFormatterLoading,
      setReFormatterData,
      setReformatterReconnectAttempts,
      reformatterReconnectAttempts,
      shouldReconnectRef,
    ]
  );

  const closeConnection = useCallback(
    (socket) => {
      shouldReconnectRef.current = false;
      if (socket) {
        socket.close();
        console.log("🔒 Reformatter WebSocket connection closed manually.");
      }
    },
    [shouldReconnectRef]
  );

  const sendMessage = useCallback((socket, payload) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(payload));
    } else {
      console.warn("⚠️ Cannot send message — WebSocket not open.");
    }
  }, []);

  return {
    connectReformatterWebSocket,
    closeConnection,
    sendMessage,
  };
};
